import React, { useState, useEffect } from "react";
import ColorFieldComponent from "../../../Components/Forms/ColorFieldComponent";
import ImageUploadComponent from "../../../Components/Forms/ImageUploadComponent";
import { ControleDocaConfiguracao } from "../../../Models/Paineis/ControleDoca/ControleDocaConfiguracao";


const ControleDocaConfiguracaoFundoTab = (props: any) => {
    const [controleDocaConfiguracao, setControleDocaConfiguracao] = useState<any>(new ControleDocaConfiguracao());

    useEffect(() => {
        setControleDocaConfiguracao(props.controleDocaConfiguracao);
    }, [props.controleDocaConfiguracao]);

    return (
        <div>
            <div className="row">
                {/* <div className="col-md-2 mb-2">
                    <ImageUploadComponent
                        className="display-none"
                        label="Logotipo"
                        field='logotipo'
                        uploadedField='file_to_upload'
                        default='KronaMaxxiReduzida.png'
                        model={controleDocaConfiguracao}
                    />
                </div> */}
                 <div className="col-md-2 mb-2 area_cor_fundo pt-4 w-100">
                    <ColorFieldComponent
                        label="Cor Fundo"
                        field='cor_fundo'
                        type='background-color'
                        colorChangedCallback={props.colorChangedCallback}  
                        model={controleDocaConfiguracao}
                    />
                </div>
            </div>

            <div className="row mt-5">
                <div className="col-md-2 mb-2">
                    <ColorFieldComponent
                        label="Cor Faixa 1"
                        field='cor_faixa_1'
                        colorChangedCallback={props.colorChangedCallback}  
                        model={controleDocaConfiguracao}
                    />
                </div>

                <div className="col-md-2 mb-2">
                    <ColorFieldComponent
                        label="Cor Faixa 2"
                        field='cor_faixa_2'
                        type='color'
                        colorChangedCallback={props.colorChangedCallback}  
                        model={controleDocaConfiguracao}
                    />
                </div> 
                <div className="col-md-2 mb-2">
                    <ColorFieldComponent
                        label="Cor Faixa 3"
                        field='cor_faixa_3'
                        colorChangedCallback={props.colorChangedCallback}  
                        model={controleDocaConfiguracao}
                    />
                </div>
                
                <div className="col-md-2 mb-2">
                    <ColorFieldComponent
                        label="Cor Faixa 4"
                        field='cor_faixa_4'
                        type='color'
                        colorChangedCallback={props.colorChangedCallback}  
                        model={controleDocaConfiguracao}
                    />
                </div> 
                {/* <div className="col-md-2 mb-2">
                    <ColorFieldComponent
                        label="Cor Faixa 5"
                        field='cor_faixa_5'
                        colorChangedCallback={props.colorChangedCallback}  
                        model={controleDocaConfiguracao}
                    />
                </div> */}
                <div className="col-md-2 mb-2">
                    <ColorFieldComponent
                        label="Cor Vazio"
                        field='cor_faixa_vazio'
                        colorChangedCallback={props.colorChangedCallback}  
                        model={controleDocaConfiguracao}
                    />
                </div>
                <span className="cor_fundo">test</span>
                <hr/>
            </div>

            <div className="row col-md-12 p-2">
                <div className="area_cor_faixa_1 col-md-2 d-flex justify-content-center align-items-center flex-column text-white" style={{ height: '100px', backgroundColor:'#1f9e5c' }}>
                    <h4 className="text-center col-md-6 mb-2"><strong className="chart-title area_cor_fonte_titulo">1</strong></h4>
                    <h5 className="text-center col-md-12"><strong className="chart-title area_cor_fonte_titulo">Faixa 1</strong></h5>
                </div>

                <div className="area_cor_faixa_2 col-md-2 d-flex justify-content-center align-items-center flex-column text-white" style={{ height: '100px', backgroundColor:'#ffea00' }}>
                    <h4 className="text-center col-md-6 mb-2"><strong className="chart-title area_cor_fonte_titulo">1</strong></h4>
                    <h5 className="text-center col-md-12"><strong className="chart-title area_cor_fonte_titulo">Faixa 2</strong></h5>
                </div>

                <div className="area_cor_faixa_3 col-md-2 d-flex justify-content-center align-items-center flex-column text-white" style={{ height: '100px', backgroundColor:'#f28705' }}>
                    <h4 className="text-center col-md-6 mb-2"><strong className="chart-title area_cor_fonte_titulo">1</strong></h4>
                    <h5 className="text-center col-md-12"><strong className="chart-title area_cor_fonte_titulo">Faixa 3</strong></h5>

                </div>

                <div className="area_cor_faixa_4 col-md-2 d-flex justify-content-center align-items-center flex-column text-white" style={{ height: '100px', backgroundColor:'#ed3238' }}>
                    <h4 className="text-center col-md-6 mb-2"><strong className="chart-title area_cor_fonte_titulo">1</strong></h4>
                    <h5 className="text-center col-md-12"><strong className="chart-title area_cor_fonte_titulo"> Faixa 4 </strong></h5>
                </div>

                {/* <div className="area_cor_faixa_5 col-md-2 d-flex justify-content-center align-items-center flex-column text-white" style={{ height: '100px', backgroundColor:'#782b24' }}>
                    <h4 className="text-center col-md-6 mb-2"><strong className="chart-title area_cor_fonte_titulo">1</strong></h4>
                    <h5 className="text-center col-md-12"><strong className="chart-title area_cor_fonte_titulo">Faixa 5 </strong></h5>
                </div> */}

                <div className="area_cor_faixa_vazio col-md-2 d-flex justify-content-center align-items-center flex-column text-white" style={{ height: '100px', backgroundColor:'#262425' }}>
                    <h4 className="text-center col-md-6 mb-2"><strong className="chart-title area_cor_fonte_titulo">1</strong></h4>
                    <h5 className="text-center col-md-12"><strong className="chart-title area_cor_fonte_titulo">Vazio</strong></h5>

                </div>
            </div>
        </div>
    );
}

export default ControleDocaConfiguracaoFundoTab;